import axios from "axios";
import CryptoJS from "crypto-js";
var BASE_URL_start = window.location.origin;

let cachedConfig = null;

export const fetchConfig = async () => {
  if (cachedConfig) return cachedConfig; // Use cached config if available

  try {
    const response = await axios.post(`${BASE_URL_start}/api/get-token`, {
      params: { url: window.location.href, userAgent: navigator.userAgent, }
    });
    cachedConfig = CryptoJS.AES.decrypt(
      response.data.encryptedData,
      'BUiJ6YioLLCKGgRJdaJZ2NTrunwJOBvf'
    )
    const decryptedData = JSON.parse(cachedConfig.toString(CryptoJS.enc.Utf8));
    var token = decryptedData.apiAuth.token; // Adjust based on API response
    var key = decryptedData.apiAuth.key; // Adjust based on API response
    var encryptedToken = CryptoJS.AES.encrypt(token, key).toString();
    localStorage.setItem("tkn", encryptedToken);
    return decryptedData;
  } catch (error) {
    console.error("Error fetching config:", error);
    return null;
  }
};